import "core-js/modules/es.object.keys.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("label", [_vm._v(_vm._s(_vm.nameDirection ? "Dirección de trabajo" : "Dirección"))])]), _vm._l(_vm.addressC, function (add, index) {
    return _c("el-row", {
      key: index,
      attrs: {
        gutter: 20
      }
    }, _vm._l(add, function (myKey, indexx) {
      return _c("el-col", {
        key: "b" + indexx,
        attrs: {
          xl: {
            span: _vm.columna
          },
          lg: {
            span: _vm.columna
          },
          md: {
            span: _vm.columna
          },
          sm: {
            span: 24
          },
          xs: {
            span: 24
          }
        }
      }, [_vm.isEmpty(_vm.address[myKey].base) ? _c("el-form-item", {
        attrs: {
          label: _vm.$t(_vm.address[myKey].nombre),
          prop: "direccion." + myKey,
          rules: _vm.address[myKey].required ? [_vm.required("")] : []
        }
      }, [_c("el-input", {
        attrs: {
          type: "text",
          "auto-complete": "no",
          placeholder: _vm.address[myKey].placeholder ? _vm.$t(_vm.address[myKey].placeholder) : _vm.$t(_vm.address[myKey].nombre),
          disabled: _vm.isReadOnly(myKey),
          maxlength: _vm.address[myKey].limit ? _vm.address[myKey].limit : 300
        },
        model: {
          value: _vm.direccion[myKey],
          callback: function callback($$v) {
            _vm.$set(_vm.direccion, myKey, $$v);
          },
          expression: "direccion[myKey]"
        }
      })], 1) : _c("el-form-item", {
        attrs: {
          label: _vm.$t(_vm.address[myKey].nombre),
          prop: "direccion." + myKey,
          rules: _vm.address[myKey].required ? [_vm.required("")] : []
        }
      }, [_c("el-select", {
        ref: myKey,
        refInFor: true,
        attrs: {
          type: "text",
          placeholder: _vm.$t(_vm.address[myKey].nombre),
          filterable: "",
          clearable: "",
          "auto-complete": "no",
          "no-data-text": _vm.address[myKey].placeholder ? _vm.$t(_vm.address[myKey].placeholder) : _vm.$t("commons.address.select_previous", {
            name: _vm.$t(_vm.address[Object.keys(_vm.address)[indexx]].nombre)
          }),
          loading: _vm.loading[_vm.address[myKey].base.toLowerCase()],
          disabled: _vm.isReadOnly(myKey) ? "disabled" : false
        },
        on: {
          input: function input($event) {
            return _vm.remote(_vm.address[myKey], myKey);
          }
        },
        model: {
          value: _vm.direccion[myKey],
          callback: function callback($$v) {
            _vm.$set(_vm.direccion, myKey, $$v);
          },
          expression: "direccion[myKey]"
        }
      }, _vm._l(_vm.levels[_vm.address[myKey].base.toLowerCase()], function (item) {
        return _c("el-option", {
          key: item.id,
          attrs: {
            label: item.nombre,
            value: item.id
          }
        });
      }), 1)], 1)], 1);
    }), 1);
  }), _vm.viewlinea ? _c("hr", {
    staticClass: "pz-dotted"
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };